import React from "react";

const NotFound = () => {

    return(
        <h1>No Encuentra</h1>
    )
}

export default NotFound;